import React, { useState } from 'react'
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  ActivityIndicator,
  TextInput,
} from 'react-native'
import { Formik } from 'formik'
import * as yup from 'yup'
import { patchAxiosAPI } from '../../../framework/src/Blocks/AxiosAPIBlock'
import CustomPopUp from '../../../framework/src/CustomPopUp'
import * as IMG_CONST from '../../../blocks/dashboard/src/assets'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import '../../../blocks/dashboard/src/editProfile.css'
import { handleAndCondition } from '../../../framework/src/Utilities'

const validationSchema = yup.object({
  full_phone_number: yup
    .string()
    .required('Phone number is required')
    .min(10, 'Must be at least 10 digits'),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters'),
})

export default function ConfirmPhoneNumber({
  handleClose,
  initialPhoneNumber = '',
}: {
  handleClose: () => void
  initialPhoneNumber: string
}) {
  const [message, setMessage] = useState('')
  const [popup, setPopup] = useState(false)
  const [loader, setLoader] = useState(false)
  const [shouldCloseModal, setShouldCloseModal] = useState(false)

  const ClosePopUp = () => {
    if (shouldCloseModal) {
      handleClose()
    }
    setPopup(false)
    setShouldCloseModal(false)
  }

  const formatErrorMessages = (errorArray: any[]) => {
    if (!Array.isArray(errorArray)) return 'An error occurred';
    
    const messages = errorArray.map(obj => Object.values(obj)[0]).join(", ")
    
    return messages
  };

  const submitData = async (values: {
    full_phone_number: string
    password: string
  }) => {
    if (initialPhoneNumber !== values.full_phone_number) {
        setPopup(true);
        setMessage('Phone number does not match. Please enter the same phone number to confirm.');
        setShouldCloseModal(false);
        return
    }
    const data = {
      full_phone_number: initialPhoneNumber,
      full_phone_number_confirmation: values.full_phone_number,
      password: values.password,
    }
    setLoader(true)
    const url = '/account_block/accounts/update_email_phone'
    await patchAxiosAPI(url, data).then((res: any) => {
        console.log('haha res', res)
        setLoader(false)
        if (res?.error) {
            const errorMessage = formatErrorMessages(res?.data || []);
            setPopup(true);
            setShouldCloseModal(false);
            setMessage(errorMessage);
        } else {
            setPopup(true);
            setShouldCloseModal(true);
            setMessage("Profile Updated Successfully! ");
        }
    })
  }

  return (
    <Formik
      initialValues={{ full_phone_number: '', password: '' }}
      validationSchema={validationSchema}
      onSubmit={(values) => submitData(values)}
    >
      {({
        errors,
        touched,
        handleChange,
        handleBlur,
        values,
        handleSubmit,
      }) => {
        const isFormValid =
          values.full_phone_number.trim() !== '' &&
          values.password.trim() !== '' &&
          Object.keys(errors).length === 0
        const isDisabled = loader || !isFormValid

        return (
          <View
            style={
              window.screen.width < 950
                ? styles.container
                : styles.desktopContainer
            }
          >
            {popup && (
              <CustomPopUp
                ClosePopUp={ClosePopUp}
                btnText="Back"
                message={message}
              />
            )}
            <View
              style={
                window.screen.width < 950 ? styles.card : styles.cardDesktop
              }
            >
              {window.screen.width < 950 ? (
                <img
                  src={IMG_CONST.illustrationRegister}
                  style={{
                    width: 216,
                    height: 234,
                    position: 'absolute',
                    top: -165,
                    left: 180,
                    zIndex: 99,
                  }}
                />
              ) : null}
              <View style={styles.bottomvalues}>
                <View style={styles.headerContainer}>
                  <Text style={styles.heading1}>Confirm Phone Number</Text>
                  <TouchableOpacity style={styles.closeButton} onPress={handleClose}>
                    <Text style={styles.closeButtonText}>×</Text>
                  </TouchableOpacity>
                </View>
                <Text style={styles.lableText}>
                  Please reconfirm your new phone number and password to
                  confirm.
                </Text>
              </View>
              <View style={{ zIndex: 1 }}>
                <PhoneInput
                  countryCodeEditable={true}
                  country={'in'}
                  buttonClass="flagsdropdown"
                  containerClass="PhoneInput customPhnInput"
                  inputClass="PhoneInputInput customPhnInput2"
                  placeholder="Enter phone number"
                  value={values.full_phone_number}
                  onChange={handleChange('full_phone_number')}
                  onBlur={handleBlur('full_phone_number')}
                />
                <View style={styles.errorContainer}>
                  {handleAndCondition(
                    touched.full_phone_number,
                    errors.full_phone_number,
                    <Text style={styles.errorText}>
                      {errors.full_phone_number}
                    </Text>,
                    <Text style={styles.errorTextPlaceholder}> </Text>
                  )}
                </View>
              </View>
              <TextInput
                style={[
                  styles.passwordInput,
                  window.screen.width < 950 && { backgroundColor: '#ffffff' },
                ]}
                placeholder="Password"
                placeholderTextColor="#b2bac6"
                secureTextEntry
                onChangeText={handleChange('password')}
                onBlur={handleBlur('password')}
                value={values.password}
              />
              <View style={styles.errorContainer}>
                {touched.password && errors.password ? (
                  <Text style={styles.errorText}>{errors.password}</Text>
                ) : (
                  <Text style={styles.errorTextPlaceholder}> </Text>
                )}
              </View>
              <TouchableOpacity
                disabled={isDisabled}
                onPress={() => handleSubmit()}
                style={isDisabled ? styles.buttonViewDisable : styles.button}
              >
                <Text style={styles.buttonText}>Confirm</Text>
                {loader && (
                  <ActivityIndicator
                    style={styles.loader}
                    size="large"
                    color="#2e2442"
                  />
                )}
              </TouchableOpacity>
            </View>
          </View>
        )
      }}
    </Formik>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column-reverse',
    backgroundColor: '#4e3e71',
  },
  loader: { position: 'absolute', left: 0, right: 0, bottom: 6 },
  desktopContainer: {
    flex: 1,
    backgroundColor: '#ffff',
  },
  card: {
    position: 'relative',
    borderTopRightRadius: 24,
    backgroundColor: '#e8fafe',
    paddingHorizontal: 16,
  },
  cardDesktop: {
    backgroundColor: 'white',
    margin: 20,
  },
  resendCode: {
    color: '#4e3e71',
    paddingVertical: 5,
    fontWeight: 'bold',
  },
  resendCode_unActive: {
    color: '#767676',
    paddingVertical: 5,
    fontWeight: 'bold',
  },
  bottomvalues: {
    paddingBottom: 20,
    paddingHorizontal: 16,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingTop: 20,
    paddingBottom: 15,
  },
  closeButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#f0f0f0',
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButtonText: {
    fontSize: 24,
    color: '#4e3e71',
    fontWeight: 'bold',
  },
  lableText: {
    color: '#4e3e71',
    justifyContent: 'center',
    fontSize: 18,
  },
  heading: {
    marginVertical: 5,
    marginHorizontal: 'auto',
    color: '#0579ed',
    fontSize: 30,
    fontWeight: 'bold',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  heading1: {
    fontSize: 32,
    textAlign: 'left',
    color: '#4e3e71',
    flex: 1,
  },
  OtpInputView: {
    marginVertical: 10,
  },
  button: {
    borderRadius: 12,
    paddingVertical: 15,
    paddingHorizontal: 50,
    backgroundColor: '#4e3e71',
    marginBottom: 20,
    marginTop: 60,
  },
  buttonViewDisable: {
    borderRadius: 12,
    paddingVertical: 15,
    paddingHorizontal: 50,
    backgroundColor: '#aa9cc9',
    marginBottom: 20,
    marginTop: 60,
  },
  buttonText: {
    color: '#e8fafe',
    fontSize: 17,
    textAlign: 'center',
  },
  textInput: {
    marginVertical: 10,
    height: 50,
    width: '100%',
    borderRadius: 8,
    fontSize: 18,
    backgroundColor: '#ffffff',
    paddingHorizontal: 15,
    borderWidth: 2,
    borderColor: '#d1d5db',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  errorText: {
    color: '#ef4444',
    fontSize: 14,
    marginTop: 3,
    marginBottom: 7,
    paddingLeft: 5,
  },
  input: {
    borderWidth: 0,
    flex: 1,
    marginVertical: 8,
    paddingVertical: 12,
    paddingLeft: 10,
    fontSize: 18,
    color: '#112950',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e5e5',
  },
  passwordInput: {
    borderWidth: 0,
    flex: 1,
    marginVertical: 8,
    paddingVertical: 12,
    paddingLeft: 10,
    fontSize: 18,
    color: '#112950',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e5e5',
  },
  errorContainer: {
    height: 24,
    justifyContent: 'flex-start',
  },
  errorTextPlaceholder: {
    color: 'transparent',
    fontSize: 14,
    marginTop: 3,
    marginBottom: 7,
    paddingLeft: 5,
    height: 14,
  },
})
